import client from '.spat/modules/client';

client.start();

; (() => {
  var snycMedia = () => {
    var media = getComputedStyle(document.documentElement).getPropertyValue('--media');
    app.media = media.trim();
    riot.update();
  };

  window.addEventListener('resize', () => {
    snycMedia();
  });
  

  snycMedia();
})();

if (app.utils.isFirst) {
  if (location.pathname === '/') {
    var modal = spat.modal.open('modal-image');
  }
  app.utils.isFirst = false;
}

